package learning.containers


import com.jingfangpai.api.clients.ContentApiClient
import com.jingfangpai.common.orm.mapping.enums.ContentType
import community.components.TopicEdit
import learning.components.TcmFaqEdit
import react.*
import react.dom.div
import setTitle

external interface TcmFaqEditPageProps : RProps {
    var id:String
}

data class TcmFaqEditPageContextData(
    var saveContent:(content:com.jingfangpai.common.orm.mapping.Content, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getContent:(type: ContentType, id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
)

val TcmFaqEditPageContext = createContext(TcmFaqEditPageContextData(ContentApiClient::saveContent,ContentApiClient::getContent))

val TcmFaqEditPageProvider = functionalComponent<TcmFaqEditPageProps> { props ->

    setTitle("FAQ编辑")

    fun placeHolderFunction(param: String) {
        console.log("doing something with param")
    }

    useEffectOnce { }

    TcmFaqEditPageContext.Provider(TcmFaqEditPageContextData(ContentApiClient::saveContent,ContentApiClient::getContent)) {
        div("TcmFaqEditPage-content") {
            child(TcmFaqEdit) {
                attrs{
                    id = props.id
                }
            }
        }
    }
}
